import React from 'react';
import { Button, message, Modal, Spin } from 'antd';
import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';
import { fetchData } from '../../middleware/fetchData';
import NoData from '../../image/none.png';
import './index.less';
import { getIsWxClient } from '../../utils/commonUtils';
import noWxWarnIcon from '../../image/noWxWarnIcon.png';
import { wxAuthorize } from '../../utils/wxUtils';

const GROUP_CODE_STYLE_DEFAULT_COLOR = '#41C1AD';

// 系统默认模版四张旧静态图上传 OSS 后，在这里填入对应后端字段的永久访问地址。
const GROUP_CODE_STYLE_DEFAULT_IMAGE_URLS = {
    headerUrl: 'https://scrmcommon.tbkdata.cn/plan/front/groupCode/default-group-code-page-header.png',
    cardBgUrl: 'https://scrmcommon.tbkdata.cn/plan/front/groupCode/default-group-code-qr-card-background.png',
    footerUrl: 'https://scrmcommon.tbkdata.cn/plan/front/groupCode/default-group-code-page-footer.png',
    authGuideUrl: 'https://scrmcommon.tbkdata.cn/plan/front/groupCode/default-group-code-authorization-guide.gif'
};

const normalizeTemplateValue = value => (typeof value !== 'undefined' && value !== null ? value : '');
const normalizeTemplateUrl = value => (typeof value === 'string' ? value.trim() : '');
const normalizeTemplateColor = value => (typeof value === 'string' ? value.trim() : normalizeTemplateValue(value));

const getTemplateImageUrl = (template, field) => {
    const url = normalizeTemplateUrl(template[field]);
    if (template.type === 'SYSTEM' && !url) return GROUP_CODE_STYLE_DEFAULT_IMAGE_URLS[field] || '';
    return url;
};

const normalizeStyleTemplate = template => {
    if (!template) return {};
    return {
        ...template,
        headerUrl: getTemplateImageUrl(template, 'headerUrl'),
        cardBgUrl: getTemplateImageUrl(template, 'cardBgUrl'),
        footerUrl: getTemplateImageUrl(template, 'footerUrl'),
        authGuideUrl: getTemplateImageUrl(template, 'authGuideUrl'),
        backgroundColor: normalizeTemplateColor(template.backgroundColor) || (template.type === 'SYSTEM' ? GROUP_CODE_STYLE_DEFAULT_COLOR : '')
    };
};

const getBackgroundImageStyle = imageUrl => (imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined);
const getBackgroundColorStyle = backgroundColor => (backgroundColor ? { backgroundColor } : undefined);
/*
    群活码展示页面
*/
class WeChatGroupCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            noWxFlag: false,
            isSecurityAdd: 'Y',
            weChatAuthAfter: false,
            dynamicAddress: {},
            canClickAuthBtn: false,
            styleTemplate: {},
        };
    }

    componentWillMount () {
        if (!getIsWxClient()) {
            this.setState({ noWxFlag: true });
            return;
        }
        this.handleInitStep();
    }

    handleInitStep = () => {
        const search = window.location.search;
        if (search.includes('code=')) {
            const searchArr = search.slice(1, search.length).split('&');
            const companyId = (searchArr.find(item => item.includes('companyId')) || '').replace('companyId=', '');
            const code = (searchArr.find(item => item.includes('code=')) || '').replace('code=', '');
            const appId = (searchArr.find(item => item.includes('appId=')) || '').replace('appId=', '');
            if (code === sessionStorage.code) {
                sessionStorage.isGrant = 'Y';
                this.setState({ weChatAuthAfter: true });
                this.handleGetGroupCodeDetail();
                return;
            }
            // 重定向进来的 code给后端 返回unionid
            fetchData('/scrm-base/pass/queryUserInfoByCode', {
                body: JSON.stringify({ code, companyId, appId })
            }).then((res) => {
                if (res && res.code === 200) {
                    const { unionId, headImgUrl, nickname, province, city, country, sex, externalUserId } = res.data;
                    sessionStorage.code = code;
                    unionId && (sessionStorage.unionId = unionId);
                    headImgUrl && (sessionStorage.headImgUrl = headImgUrl);
                    nickname && (sessionStorage.nickname = nickname);
                    province && (sessionStorage.province = province);
                    city && (sessionStorage.city = city);
                    country && (sessionStorage.country = country);
                    sex && (sessionStorage.sex = sex);
                    externalUserId && (sessionStorage.externalUserId = externalUserId || '');
                    sessionStorage.isGrant = 'Y';
                    this.setState({ weChatAuthAfter: true });
                    this.handleGetGroupCodeDetail();
                }
            });
        } else {
            // 刚跳进来后获取URL上携带参数 codeId 活码id companyId 公司id channelId 渠道id
            const searchArr = search.slice(1, search.length).split('&');
            const companyId = (searchArr.find(item => item.includes('companyId')) || '').replace('companyId=', '');
            const codeId = (searchArr.find(item => item.includes('codeId')) || '').replace('codeId=', '');
            const channelId = (searchArr.find(item => item.includes('channelId')) || '').replace('channelId=', '');
            const phone = (searchArr.find(item => item.includes('phone')) || '').replace('phone=', '');
            const followUserId = (searchArr.find(item => item.includes('followUserId')) || '').replace('followUserId=', '');
            const fixId = (searchArr.find(item => item.includes('fixId')) || '').replace('fixId=', '');
            // 存储url上的参数
            companyId && (sessionStorage.companyId = companyId);
            codeId && (sessionStorage.codeId = codeId);
            channelId && (sessionStorage.channelId = channelId);
            phone && (sessionStorage.phone = phone);
            followUserId && (sessionStorage.followUserId = followUserId);
            fixId && (sessionStorage.fixId = fixId);
            // 判断是否需要公众号授权
            fetchData('/scrm-wechat/pass/isGroupGrant', {
                body: JSON.stringify({ companyId, codeId })
            }).then((response) => {
                const { styleTemplate } = response.data || {};
                const nextStyleTemplate = normalizeStyleTemplate(styleTemplate);
                if (response.data.isGrant === 'Y') {
                    sessionStorage.isGrant = 'Y';
                    this.setState({
                        dynamicAddress: { fixDomain: response.data.fixDomain },
                        styleTemplate: nextStyleTemplate
                    });
                } else {
                    sessionStorage.isGrant = '';
                    this.setState({ styleTemplate: nextStyleTemplate }, this.handleGetGroupCodeDetail);
                }
            });
        }
    }

    // 跳转授权
    jumpToWeChatAuth = () => {
        // 1.公司id去拿公众号授权参数 appid component_appid
        fetchData('/scrm-base/pass/queryAppInfo', {
            body: JSON.stringify({ companyId: sessionStorage.companyId, scene: 'GROUP', businessId: sessionStorage.codeId })
        }).then((res) => {
            if (res && res.code === 200) {
                const { appId, platformAppId } = res.data;
                const { fixDomain } = this.state.dynamicAddress;
                wxAuthorize({
                    companyId: sessionStorage.companyId,
                    scene: 'GROUP',
                    businessId: sessionStorage.codeId,
                    appId,
                    platformAppId,
                    fixDomain,
                });
            }
        });
    }

    // 获取微信码的详情
    handleGetGroupCodeDetail = () => {
        const search = window.location.search;
        const searchArr = search.slice(1, search.length).split('&');
        let params = {};
        if (sessionStorage.isGrant === 'Y') {
            params = {
                unionId: sessionStorage.unionId,
                headImg: sessionStorage.headImgUrl,
                nickName: sessionStorage.nickname,
                province: sessionStorage.province,
                city: sessionStorage.city,
                country: sessionStorage.country,
                sex: sessionStorage.sex,
                externalUserId: sessionStorage.externalUserId
            };
        }
        searchArr.forEach(item => {
            let itemArr = [item.slice(0, item.indexOf('=')), item.slice(item.indexOf('=') + 1, item.length)];;
            if (['codeId', 'companyId', 'channelId', 'phone', 'followUserId', 'fixId'].includes(itemArr[0])) {
                itemArr[1] && (itemArr[1] !== 'undefined') && (params[itemArr[0]] = decodeURIComponent(itemArr[1]));
            }
        });
        fetchData('/scrm-wechat/pass/groupCodeDetail', {
            body: JSON.stringify({ ...params })
        }).then((res) => {
            const detail = res.data || {};
            const { name } = detail;
            const nextStyleTemplate = detail.styleTemplate ? normalizeStyleTemplate(detail.styleTemplate) : this.state.styleTemplate;
            document.title = name || '';
            this.setState({
                ...detail,
                styleTemplate: nextStyleTemplate,
                loading: false,
            });
        });
    }

    // 展示咨询师弹窗
    handleShowConsultantModal = () => {
        this.setState({
            isShowConsultantModal: true,
        });
    }

    // 关闭咨询师弹窗
    handleCancelConsultantModal = () => {
        this.setState({
            isShowConsultantModal: false,
        });
    }

    onTouchStart = () => {
        const { messageKey = '' } = this.state;
        const search = window.location.search;
        const searchArr = search.slice(1, search.length).split('&');
        let params = {};
        if (sessionStorage.isGrant === 'Y') {
            params = {
                unionId: sessionStorage.unionId,
                headImg: sessionStorage.headImgUrl,
                nickName: sessionStorage.nickname,
                province: sessionStorage.province,
                city: sessionStorage.city,
                country: sessionStorage.country,
                sex: sessionStorage.sex,
                externalUserId: sessionStorage.externalUserId
            };
        }
        searchArr.forEach(item => {
            let itemArr = item.split('=');
            if (['codeId', 'companyId', 'channelId', 'phone', 'followUserId', 'fixId'].includes(itemArr[0])) {
                itemArr[1] && (itemArr[1] !== 'undefined') && (params[itemArr[0]] = decodeURIComponent(itemArr[1]));
            }
        });
        this.timeOutEvent = setTimeout(() => {
            this.timeOutEvent = 0;
            // 长按了
            if (messageKey) {
                fetchData('/scrm-wechat/pass/groupCodePress', {
                    body: JSON.stringify({ messageKey, ...params })
                }).then((res) => {
                    console.log('长按统计=>成功');
                });
            } else {
                console.log('缺少messageKey');
            }
        }, 400);
    }

    onTouchMove = () => {
        clearTimeout(this.timeOutEvent);
        this.timeOutEvent = 0;
    }
    onTouchEnd = () => {
        clearTimeout(this.timeOutEvent);
        if (this.timeOutEvent !== 0) {
            // 点击了
        }
        return false;
    }

    handleDeleteTips = () => {
        this.setState({
            isSecurityAdd: 'N',
        });
    }

    renderQrCodeContent = () => {
        const {
            qrCode = '', // 二维码地址
            messageKey = '', // 消息key
            isBlack = 'N', // 是否拉黑
            isSecurityAdd = 'Y', // 是否添加安全验证提示(Y是N否）
            name, //活码名称
            guideWords = '长按扫码入群获取直播链接', // 引导语
            spareUserQrCode = '', // 预留客服二维码
            type = 'GROUP_QR_CODE', // 群活码GROUP_QR_CODE/预留咨询师SINGLE_QR_CODE
            loading,
            styleTemplate
        } = this.state;
        const currentStyleTemplate = normalizeStyleTemplate(styleTemplate);
        return (
            loading ? <Spin spinning={true} style={{ width: '100%', marginTop: '200px' }} /> : (isBlack === 'Y' || !qrCode) ? (
                <div className="no-data">
                    <img src={NoData} alt="" />
                    <div className="text">抱歉，由于活动参与人数过多，请稍后重试</div>
                </div>
            ) : (
                <React.Fragment>
                    {isSecurityAdd === 'Y' ? (
                        <div className="safe-tips">
                            <div>
                                <CheckCircleFilled style={{ color: '#16C96D', fontSize: '0.14rem' }} />
                                <span className="tips">此二维码已通过安全验证，可以放心扫描 </span>
                            </div>
                            <CloseOutlined style={{ color: '#16C96D', fontSize: '0.14rem' }} onClick={() => this.handleDeleteTips()} />
                        </div>
                    ) : null}
                    <div className='header-image-content'>
                        {currentStyleTemplate.headerUrl ? <img src={currentStyleTemplate.headerUrl} alt="" className="headerImg" /> : null}
                    </div>
                    <div className='middle-image-content'>
                        <div className="main-content" style={getBackgroundImageStyle(currentStyleTemplate.cardBgUrl)}>
                            <div className="code-name">{type === 'GROUP_QR_CODE' ? guideWords : '添加客服微信，接受入群邀请'}</div>
                            <div className="qrcode-content">
                                <img src={qrCode} alt="" className="qrcode" onTouchStart={this.onTouchStart} onTouchMove={this.onTouchMove} onTouchEnd={this.onTouchEnd} />
                            </div>
                        </div>
                    </div>
                    <div className='bottom-image-content'>
                        {currentStyleTemplate.footerUrl ? <img src={currentStyleTemplate.footerUrl} alt="" className="bottomImg" /> : null}
                        {type === 'GROUP_QR_CODE' && spareUserQrCode ? (
                            <div className="help-content">
                                <span className="tips">遇到问题？</span>
                                <span className="btn" onClick={this.handleShowConsultantModal}>{'添加客服微信 >'}</span>
                            </div>
                        ) : null}
                    </div>
                </React.Fragment>
            )
        );
    }

    renderQrCodeContentNeedAuth = () => {
        const {
            isSecurityAdd,
            styleTemplate
        } = this.state;
        const currentStyleTemplate = normalizeStyleTemplate(styleTemplate);
        return (
            <React.Fragment>
                {isSecurityAdd === 'Y' ? (
                    <div className="safe-tips">
                        <div>
                            <CheckCircleFilled style={{ color: '#16C96D', fontSize: '0.14rem' }} />
                            <span className="tips">此二维码已通过安全验证，可以放心扫描 </span>
                        </div>
                        <CloseOutlined style={{ color: '#16C96D', fontSize: '0.14rem' }} onClick={() => this.handleDeleteTips()} />
                    </div>
                ) : null}
                <div className='header-image-content'>
                    {currentStyleTemplate.headerUrl ? <img src={currentStyleTemplate.headerUrl} alt="" className="headerImg" /> : null}
                </div>
                <div className='middle-image-content'>
                    <div className="main-content" style={getBackgroundImageStyle(currentStyleTemplate.cardBgUrl)}>
                        <div className="code-name"></div>
                        <div className="qrcode-content">
                            {currentStyleTemplate.authGuideUrl ? <img src={currentStyleTemplate.authGuideUrl} alt="" className="codeBg" onClick={() => this.jumpToWeChatAuth()} /> : null}
                        </div>
                    </div>
                </div>
                <div className='bottom-image-content'>
                    {currentStyleTemplate.footerUrl ? <img src={currentStyleTemplate.footerUrl} alt="" className="bottomImg" /> : null}
                </div>
            </React.Fragment>
        );
    }

    render () {
        const {
            spareUserQrCode = '', // 预留客服二维码
            noWxFlag,
            weChatAuthAfter,
            styleTemplate
        } = this.state;
        const currentStyleTemplate = normalizeStyleTemplate(styleTemplate);
        return (
            <div className="wechat-group-code-content" style={getBackgroundColorStyle(currentStyleTemplate.backgroundColor)}>
                {
                    noWxFlag ? <div className="no-data">
                        <img src={noWxWarnIcon} alt="" style={{ height: 'auto' }} />
                        请在微信客户端打开
                    </div> : (
                        sessionStorage.isGrant === 'Y' && !weChatAuthAfter ? (
                            this.renderQrCodeContentNeedAuth()
                        ) : (
                            this.renderQrCodeContent()
                        )
                    )
                }
                {this.state.isShowConsultantModal && (
                    <Modal
                        visible
                        title={null}
                        footer={null}
                        className="consultant-code-modal"
                        onCancel={this.handleCancelConsultantModal}
                    >
                        <div className="qrcode-content">
                            <img src={spareUserQrCode} alt="" className="qrcode" />
                        </div>
                        <div className="tips">如果无法入群，请扫码添加客服微信</div>
                    </Modal>
                )}
            </div>
        );
    }
}

export { WeChatGroupCode };
